<template>
  <v-container fluid class="container-sequences">
    <v-layout justify-center>
      <v-flex lg10>
        <perseu-card :title="title">
          <template slot="content">
            <v-container grid-list-md>
              <v-layout>
                <v-flex lg2>
                  <select-type
                    label="Tipo"
                    v-model="sequence.type"
                    :disabled="editMode"
                    @change="listItems"
                  />
                </v-flex>
                <v-flex lg4>
                  <v-text-field v-model="sequence.name" label="Nome" />
                </v-flex>
                <v-flex lg3>
                  <select-lang v-model="sequence.lang" label="Idioma" />
                </v-flex>
              </v-layout>
              <v-row>
                <v-col cols="6">
                  <div class="d-flex justify-start"  style="margin-top:-14px; margin-bottom:-20px">
                    <v-switch
                      v-if="sequence.type && isAggregationApplicable(sequence.type.slug)"
                      v-model="sequence.isAggregation"
                      :disabled="!!sequence.id"
                      @change="listItems"
                      label="Agrupamento"
                    />
                  </div>
                </v-col>
                <v-col cols="6">
                  <div class="d-flex justify-end">
                    <v-btn color="error" @click="cancel" class="mr-2">
                      Cancelar
                    </v-btn>
                    <v-btn color="primary" @click="save">Salvar</v-btn>
                  </div>
                </v-col>
              </v-row>
            </v-container>
            <v-divider></v-divider>
            <v-layout class="mt-4" justify-space-between>
              <v-flex xs6>
                <v-layout justify-center>
                  <v-flex xs10>
                    <v-card>
                      <v-card-title class="justify-center" style="font-size:16px;cursor:default;">
                        {{ listTitle('notAssigned') }}
                      </v-card-title>
                      <v-divider></v-divider>
                      <v-card-text>
                        <v-list two-line>
                          <draggable
                            class="draggable unassigned-points"
                            group="points"
                            v-model="notAssignedItems"
                            :clone="assignItem"
                          >
                            <template
                              v-for="(item, index) in notAssignedItems"
                            >
                              <order-item-card
                                :key="index"
                                class="mt-2"
                                :item="item"
                                :show-order="false"
                                icon-button="arrow_forward"
                                :type="sequence.type.slug"
                                @click="openDialogToAssign(item, index)"
                                tooltip-button="Atribuir item na sequência"
                              />
                            </template>
                          </draggable>
                        </v-list>
                      </v-card-text>
                    </v-card>
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex xs6>
                <v-layout justify-center>
                  <v-flex xs10>
                    <v-card>
                      <v-card-title class="justify-center" style="font-size:16px;cursor:default;">
                        {{ listTitle('assigned') }}
                      </v-card-title>
                      <v-divider></v-divider>
                      <v-card-text>
                        <v-list two-line>
                          <draggable
                            v-model="assignedItems"
                            class="draggable assigned-points"
                            group="points"
                            :move="deleteOrder"
                            :clone="unassignItem"
                          >
                            <template v-for="(item, index) in assignedItems">
                              <order-item-card
                                class="mt-2"
                                :key="index"
                                :item="item"
                                :order="index"
                                :show-order="true"
                                icon-button="arrow_back"
                                :type="sequence.type.slug"
                                tooltip-button="Desatribuir item da sequência"
                                @click="revokeAssigned(item, index)"
                                @updateSubItems="updateAssignetSubItens"
                              />
                            </template>
                          </draggable>
                        </v-list>
                      </v-card-text>
                    </v-card>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </template>
        </perseu-card>
      </v-flex>
    </v-layout>
    <v-dialog v-model="assignFunction.dialog" max-width="600">
      <v-card>
        <v-card-title>Defina a ordem do item que você deseja atribuir</v-card-title>
        <v-card-text>
          <v-text-field
            label="Ordem"
            v-model.number="assignFunction.moveOrder"
            @keyup.enter="assignItemWithDialog"
          />
        </v-card-text>
        <v-card-actions class="justify-center">
          <v-btn @click="assignItemWithDialog" color="secondary">
            Atribuir
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
  import draggable from "vuedraggable";
  import { pagesNames } from "@/router/pages-names";
  import { save, findOne, deleteItemOrder, deleteSubItemOrder } from "@/services/sequences-service";
  import { find as getTumoralPhenomena } from "@/services/tumoral-phenomena-service";
  import { find as getVascularPhenomena } from "@/services/vascular-phenomena-service";
  import { find as getPotentialSpaces } from "@/services/potential-spaces-service";
  import { findAll as getFlowTypes } from "@/services/flow-types-service";
  import { findTypes as getOligoelements } from "@/services/oligoelements-service";
  import { getAll as getChakras } from "@/services/chakras-service";
  import { getAll as getChromosomes } from "@/services/chromosomes-service";
  import { findAll as getComplementaryTherapies } from "@/services/complementary-therapies";
  import { findForSequenceByType } from "@/services/aggregations-service";
  import { findTrackingPointsByType, findForSequence as getBiomagneticPairs } from "@/services/pares-biomagneticos-service";
  import {TypesSlugsEnum, isCustomTypeSlug, isTrakingPointTypeSlug, isAggregationApplicable} from "@/domain/types_slugs.enum";

  export default {
    components: {
      draggable,
      "order-item-card": () => import("@/components/Sequence/OrderItem"),
      "select-type": () => import("@/components/Sequence/Select"),
    },

    data: () => ({
      sequence: {
        type: {},
        pointOrder: [],
        tumoralPhenomenonOrder: [],
        vascularPhenomenonOrder: [],
        potentialSpaceOrder: [],
        flowTypeOrder: [],
        oligoelementOrder: [],
        chakraOrder: [],
        chromosomeOrder: [],
        complementarTherapyOrder: [],
        biomagneticPairTypesOrder: [],
        aggregationOrder: [],
      },
      assignedItems: [],
      notAssignedItems: [],
      assignFunction: {
        dialog: false,
        moveOrder: null,
        selectedItem: {},
        selectedIndex: null,
      },
    }),

    computed: {
      title() {
        return (this.sequence.id ? "Editar" : "Nova") + " Sequência";
      },
      editMode() {
        return !!this.$route.query.id;
      },
    },
    
    methods: {
        handleBeforeSave() {
          const slug = this.sequence.type.slug;
          const isCustomType = isCustomTypeSlug(slug);
          const isTrakingPointType = isTrakingPointTypeSlug(slug);

          // When the sequence type is not customized, we use pointOrder
          if (!isCustomType && !isTrakingPointType) {
            if (this.sequence.isAggregation) {
              this.sequence.aggregationOrder = this.assignedItems.map((ao, index) => {
                delete ao.aggregation;

                const adjustedAO = { ...ao };

                if (!this.sequence.id) {
                  adjustedAO.id = null;
                  adjustedAO?.sequenceAggregationPairOrder?.forEach((sap) => {
                    sap.sequenceAggregationOrder = null;
                  });
                }

                return {
                  ...adjustedAO,
                  order: index,
                };
              });
              return;
            } else {
              this.sequence.biomagneticPairTypesOrder = this.assignedItems.map((po, index) => {
                return {
                  ...po,
                  order: index,
                };
              });
            }
          }

          if (isTrakingPointType) {
            this.sequence.pointOrder = this.assignedItems.map((po, index) => {
              delete po.trackingPoint.image;
              return {
                ...po,
                order: index,
              };
            });
          }

          if (isCustomType) {
            if (slug === TypesSlugsEnum.FENOMENOS_TUMORAIS) {
              this.sequence.tumoralPhenomenonOrder = this.assignedItems.map((to, index) => {
                return {
                  ...to,
                  order: index,
                };
              });
              return;
            } else if (slug === TypesSlugsEnum.FENOMENOS_VASCULARES) {
              this.sequence.vascularPhenomenonOrder = this.assignedItems.map((vo, index) => {
                return {
                  ...vo,
                  order: index,
                };
              });
              return;
            } else if (slug === TypesSlugsEnum.ESPACOS_POTENCIAIS) {
              this.sequence.potentialSpaceOrder = this.assignedItems.map((po, index) => {
                return {
                  ...po,
                  order: index,
                };
              });
              return;
            } else if (slug === TypesSlugsEnum.TIPOS_DE_FLUXO) {
              this.sequence.flowTypeOrder = this.assignedItems.map((fo, index) => {
                return {
                  ...fo,
                  order: index,
                };
              });
              return;
            } else if (slug === TypesSlugsEnum.OLIGOELEMENTOS) {
              this.sequence.oligoelementOrder = this.assignedItems.map((oo, index) => {
                return {
                  ...oo,
                  order: index,
                };
              });
              return;
            } else if (this.sequence.type.slug === TypesSlugsEnum.CHAKRAS) {
              this.sequence.chakraOrder = this.assignedItems.map((co, index) => {
                return {
                  ...co,
                  order: index,
                };
              });
              return;
            } else if (slug === TypesSlugsEnum.CHROMOSOMES) {
              this.sequence.chromosomeOrder = this.assignedItems.map((co, index) => {
                return {
                  ...co,
                  order: index,
                };
              });
              return;
            } else if (slug === TypesSlugsEnum.TERAPIAS_COMPLEMENTARES) {
              this.sequence.complementarTherapyOrder = this.assignedItems.map((cto, index) => {
                return {
                  ...cto,
                  order: index,
                };
              });
              return;
            }
          }
        },
        isAggregationApplicable(slug) {
          return isAggregationApplicable(slug);
        },
        async save() {
          try {
            this.$store.dispatch("loading/openDialog");
            this.handleBeforeSave();
            await save(this.sequence);
            this.$toasted.global.defaultSuccess();
            this.$router.push({ name: pagesNames.SEQUENCES_LIST });
          } catch (error) {
            this.$errorHandler(error);
          } finally {
            this.$store.dispatch("loading/closeDialog");
          }
        },

        async findOne() {
          try {
            this.$store.dispatch("loading/openDialog");
            let { data } = await findOne(this.$route.query.id);
            this.sequence = data.sequence;
            
            const slug = this.sequence.type.slug;
            const isCustomType = isCustomTypeSlug(slug);
            const isTrakingPointType = isTrakingPointTypeSlug(slug);
            
            // When the sequence type is not customized, we use pointOrder
            if (!isCustomType && !isTrakingPointType) {
              if (data.sequence.isAggregation) {
                const leftItems = data.notAssignedAggregations.map((item) => ({
                  id: null,
                  order: null,
                  aggregation: item,
                  aggregationId: item.id,
                  sequenceAggregationPairOrder: []
                }));

                this.notAssignedItems = leftItems;
                this.assignedItems = data.sequence.aggregationOrder.map((item) => {
                  return {
                    ...item,
                    sequenceAggregationPairOrderOriginal: [ ...item.sequenceAggregationPairOrder ] || [],
                  };
                });

                return;
              } else {
                this.assignedItems = data.sequence.biomagneticPairTypesOrder;
                this.notAssignedItems = data.notAssignedBiomagneticPair.map((item) => ({
                  id: null,
                  order: null,
                  par: item,
                  parId: item.id,
                }));
              }
            }
            
            if (isTrakingPointType) {
              this.assignedItems = data.sequence.pointOrder;
              this.notAssignedItems = data.notAssignedPoints.map((item) => ({
                id: null,
                order: null,
                trackingPoint: item,
                trackingPointId: item.id,
              }));
              return;
            }

            if (isCustomType) {
              if( slug === TypesSlugsEnum.FENOMENOS_TUMORAIS) {
                this.assignedItems = data.sequence.tumoralPhenomenonOrder;
                this.notAssignedItems = data.notAssignedTumoralPhenomena.map((item) => ({
                  id: null,
                  order: null,
                  tumoralPhenomenon: item,
                  tumoralPhenomenonId: item.id,
                }));
  
              } else if (slug === TypesSlugsEnum.FENOMENOS_VASCULARES) {
                this.assignedItems = data.sequence.vascularPhenomenonOrder;
                this.notAssignedItems = data.notAssignedVascularPhenomena.map((item) => ({
                  id: null,
                  order: null,
                  vascularPhenomenon: item,
                  vascularPhenomenonId: item.id,
                }));
  
              } else if (slug === TypesSlugsEnum.ESPACOS_POTENCIAIS) {
                this.assignedItems = data.sequence.potentialSpaceOrder;
                this.notAssignedItems = data.notAssignedPotentialSpaces.map((item) => ({
                  id: null,
                  order: null,
                  potentialSpace: item,
                  potentialSpaceId: item.id,
                }));
  
              } else if (slug === TypesSlugsEnum.TIPOS_DE_FLUXO) {
                this.assignedItems = data.sequence.flowTypeOrder;
                this.notAssignedItems = data.notAssignedFlowTypes.map((item) => ({
                  id: null,
                  order: null,
                  flowType: item,
                  flowTypeId: item.id,
                }));
  
              } else if (slug === TypesSlugsEnum.OLIGOELEMENTOS) {
                this.assignedItems = data.sequence.oligoelementOrder;
                this.notAssignedItems = data.notAssignedOligoelements.map((item) => ({
                  id: null,
                  order: null,
                  oligoelement: item,
                  oligoelementId: item.id,
                }));
  
              } else if (this.sequence.type.slug === TypesSlugsEnum.CHAKRAS) {
                this.assignedItems = data.sequence.chakraOrder;
                this.notAssignedItems = data.notAssignedChakras.map((item) => ({
                  id: null,
                  order: null,
                  chakra: item,
                  chakraId: item.id,
                }));
              } else if (slug === TypesSlugsEnum.CHROMOSOMES) {
                this.assignedItems = data.sequence.chromosomeOrder;
                this.notAssignedItems = data.notAssignedChromosomes.map((item) => ({
                  id: null,
                  order: null,
                  chromosome: item,
                  chromosomeId: item.id,
                }));
              } else if (slug === TypesSlugsEnum.TERAPIAS_COMPLEMENTARES) {
                this.assignedItems = data.sequence.complementarTherapyOrder;
                this.notAssignedItems = data.notAssignedComplementarTherapies.map((item) => ({
                  id: null,
                  order: null,
                  complementarTherapy: item,
                  complementarTherapyId: item.id,
                }));
              }
            }
          } catch (error) {
            this.$toasted.global.defaultError();
          } finally {
            this.$store.dispatch("loading/closeDialog");
          }
        },

        async listItems() {

          const getNewID = (min = 99999, max = 999999) => (
            Math.floor(Math.random() * (max - min + 1)) + min
          );

          if (this.sequence.type) {
            const slug = this.sequence.type.slug;
            const isCustomType = isCustomTypeSlug(slug);
            const isTrakingPointType = isTrakingPointTypeSlug(slug);

            if (!isCustomType && !isTrakingPointType) {
              if (this.sequence.isAggregation) {
                const { data } = await findForSequenceByType(this.sequence.type.id);
                this.notAssignedItems = data.map((item) => ({
                  id: getNewID(),
                  order: null,
                  aggregation: item,
                  aggregationId: item.id,
                }));
                return;
              } else {
                const { data } = await getBiomagneticPairs(this.sequence.type.id);
                this.notAssignedItems = data.map((item) => ({
                  id: null,
                  order: null,
                  par: item,
                  parId: item.id,
                }));
                return;
              }
            }

            if (isTrakingPointType) {
              const ids = this.sequence.pointOrder.map((po) => po.trackingPoint.id);
              const { data } = await findTrackingPointsByType(
                this.sequence.type.id,
                ids
              );
              this.notAssignedItems = data.map((item) => ({
                  id: null,
                  order: null,
                  trackingPoint: item,
                  trackingPointId: item.id,
                }));
            }

            if (isCustomType) {
              if (this.sequence.type.slug == TypesSlugsEnum.FENOMENOS_TUMORAIS) {
                const { data } = await getTumoralPhenomena({ active:true });
                this.notAssignedItems = data.map((item) => ({
                  id: null,
                  order: null,
                  tumoralPhenomenon: item,
                  tumoralPhenomenonId: item.id,
                }));
                return;
              } else if (this.sequence.type.slug == TypesSlugsEnum.FENOMENOS_VASCULARES) {
                const { data } = await getVascularPhenomena({ active:true });
                this.notAssignedItems = data.map((item) => ({
                  id: null,
                  order: null,
                  vascularPhenomenon: item,
                  vascularPhenomenonId: item.id,
                }));
                return;
              } else if (this.sequence.type.slug == TypesSlugsEnum.ESPACOS_POTENCIAIS) {
                const { data } = await getPotentialSpaces({ active:true });
                this.notAssignedItems = data.map((item) => ({
                  id: null,
                  order: null,
                  potentialSpace: item,
                  potentialSpaceId: item.id,
                }));
                return;
              } else if (this.sequence.type.slug == TypesSlugsEnum.TIPOS_DE_FLUXO) {
                const { data } = await getFlowTypes({ active:true });
                this.notAssignedItems = data.map((item) => ({
                  id: null,
                  order: null,
                  flowType: item,
                  flowTypeId: item.id,
                }));
                return;
              } else if (this.sequence.type.slug == TypesSlugsEnum.OLIGOELEMENTOS) {
                const { data } = await getOligoelements({ active:true });
                this.notAssignedItems = data.map((item) => ({
                  id: null,
                  order: null,
                  oligoelement: item,
                  oligoelementId: item.id,
                }));
                return;
              } else if (this.sequence.type.slug === TypesSlugsEnum.CHAKRAS) {
                const { data } = await getChakras({ active:true });
                this.notAssignedItems = data.map((item) => ({
                  id: null,
                  order: null,
                  chakra: item,
                  chakraId: item.id,
                }));
                return;
              } else if (this.sequence.type.slug == TypesSlugsEnum.CHROMOSOMES) {
                const { data } = await getChromosomes({ active:true });
                this.notAssignedItems = data.map((item) => ({
                  id: null,
                  order: null,
                  chromosome: item,
                  chromosomeId: item.id,
                }));
                return;
              } else if (this.sequence.type.slug == TypesSlugsEnum.TERAPIAS_COMPLEMENTARES) {
                const { data } = await getComplementaryTherapies({ active:true });
                this.notAssignedItems = data.map((item) => ({
                  id: null,
                  order: null,
                  complementarTherapy: item,
                  complementarTherapyId: item.id,
                }));
                return;
              }
            }
          }
        },

        async initialize() {
          if (this.$route.query.id) {
            await this.findOne();
          }
        },

        cancel() {
          this.$router.go(-1);
        },
        
        openDialogToAssign(item, indexNotAssigned) {
          this.assignFunction.selectedIndex = indexNotAssigned;
          this.assignFunction.selectedItem = item;
          this.assignFunction.dialog = true;
        },

        assignItemWithDialog() {
          if (this.assignFunction.moveOrder) {
            const item = { ...this.assignFunction.selectedItem, sequenceAggregationPairOrder: [] }
            const index = this.assignFunction.moveOrder - 1;
            this.assignedItems.splice(index, 0, item);
            this.notAssignedItems.splice(this.assignFunction.selectedIndex, 1);
            this.assignFunction.selectedItem = {};
            this.assignFunction.moveOrder = null;
            this.assignFunction.dialog = false;
            this.$toasted.global.defaultSuccess();
          }
        },

        assignItem(value) {
          return { ...value, sequenceAggregationPairOrder: [] };
        },

        deleteOrder(value) {
          if (value.to.className === "draggable unassigned-points") {
            deleteItemOrder(this?.sequence.type, value.draggedContext.element);
            this.$toasted.global.defaultSuccess();
          }
        },

        unassignItem(value) {
          return { ...value };
        },

        updateAssignetSubItens(orderItemId, currentSubItems, removedSubItems) {
          const newAssignedItems = this.assignedItems.map((item) => {
            if (item.id === orderItemId) {
              return { ...item, sequenceAggregationPairOrder: currentSubItems };
            }
            return item;
          });
          
          this.assignedItems = [ ...newAssignedItems ];

          removedSubItems.forEach((removedSubItem) => {
            if (!removedSubItem.id) {
              return;
            }
            deleteSubItemOrder(this?.sequence.type, removedSubItem);
            this.$toasted.global.defaultSuccess();           
          });
        },

        revokeAssigned(itemAssigned, indexAssigned) {
          deleteItemOrder(this?.sequence.type, itemAssigned);
          const unassignedPoint = { ...itemAssigned };
          this.assignedItems.splice(indexAssigned, 1);
          this.notAssignedItems.push(unassignedPoint);
          this.$toasted.global.defaultSuccess();
        },

        listTitle(type) {
          if (this?.sequence?.type) {
            const slug = this.sequence.type.slug;
            const isCustomType = isCustomTypeSlug(slug);
            const isTrakingPointType = isTrakingPointTypeSlug(slug);
            
            var entityName = !isTrakingPointType ? this.sequence.isAggregation ? 'Agrupamentos' : 'Pares' : 'Pontos'

            if (isCustomType) {
              entityName = this.sequence.type.name;
            }

            return (type === 'notAssigned')
              ? `${entityName} não atribuídos`
              : `${entityName} atribuídos`;
          }

          if (type === 'notAssigned') {
            return 'Pontos não atribuídos';
          } else if (type === 'assigned') {
            return 'Pontos atribuídos';
          }
          return 'Lista de pontos';
        },
      },
      
      created() {
        this.initialize();
      },
  };
</script>
<style scoped>
  .draggable {
    min-height: 50px;
  }
  .container-sequences {
    min-width: 768px;
  }
</style>
